import React, { useEffect, useState, FunctionComponent } from 'react';
import { useLocation } from '@reach/router';
import axios from 'axios';

import useWidgetQuery from '@bitcoin-portal/bitcoincom-pkg-components/dist/BuyWidgetV2/hooks/useWidgetQuery';
import MoonpayWidget from '@bitcoin-portal/bitcoincom-pkg-components/dist/BuyWidgetV2/ProviderWidgets/MoonpayWidget/MoonpayWidget';
import { ProviderBaseProps } from '@bitcoin-portal/bitcoincom-pkg-components/dist/BuyWidgetV2/types';
import OnRamperWidget from '@bitcoin-portal/bitcoincom-pkg-components/dist/BuyWidgetV2/ProviderWidgets/OnRamperWidget/OnRamperWidget';

import { activeEnv } from '../../data/constants';
import { DEFAULT_CRYPTO } from '../../constants';

interface ExtendedProps extends ProviderBaseProps {
  address: string;
}

interface Props {
  provider?: string;
  isProviderPage?: boolean;
  crypto?: string;
}

const WidgetV2: FunctionComponent<Props> = ({
  provider: provProp,
  isProviderPage = false,
  crypto: cryptoProp,
  // eslint-disable-next-line consistent-return
}) => {
  const { state, search } = useLocation();

  const [countryCode, setCountryCode] = useState('');

  const moonpaySupportCountry = [
    "AT", "BE", "BG", "CH", "CY", "CZ", "DE", "DK", "EE", "ES",
    "FI", "FR", "GR", "HR", "HU", "IE", "IS", "IT", "LT", "LU",
    "LV", "MT", "NL", "NO", "PL", "PT", "RO", "SE", "SI", "SK",
    "UK", "US", "GB"
  ];

  useEffect(() => {
    axios
      .get('https://neko-web.api.wallet.bitcoin.com/api/v1/location/info')
      .then(response => {
        if (response.data.countryCode) {
          setCountryCode(response.data.countryCode);
        }
      })
      .catch(err => {
        console.error('Error fetching geolocation:', err);
      });
  }, []);

  const query = useWidgetQuery(search);

  const queryOrState = { ...(state as ExtendedProps), ...query };

  const { crypto, amount, address, fiat, provider: provQuery } = queryOrState;

  const cryptoExtract = cryptoProp?.toUpperCase();

  const provider = provProp || provQuery;

  if (provider === 'onrampmoney' || provider === 'banxa') {
    return (
      <OnRamperWidget
        crypto={cryptoExtract ?? crypto ?? DEFAULT_CRYPTO}
        amount={amount}
        fiat={fiat}
        provider={provider}
        isSell
        style={{ height: 650, border: 'none', width: '100%' }}
      />
    );
  }

  if (provider === 'moonpay') {
    return (
      <MoonpayWidget
        env={activeEnv}
        address={address}
        crypto={cryptoExtract ?? crypto}
        amount={amount}
        fiat={fiat}
        isSell
      />
    );
  }

  if (!provider && !moonpaySupportCountry.includes(countryCode)) {
    return (
      <OnRamperWidget
        crypto={cryptoExtract ?? crypto ?? DEFAULT_CRYPTO}
        amount={amount}
        fiat={fiat}
        provider={provider}
        isSell
        style={{ height: 650, border: 'none', width: '100%' }}
      />
    );
  }

  if (!provider && moonpaySupportCountry.includes(countryCode)) {
    return (
      <MoonpayWidget
        env={activeEnv}
        address={address}
        crypto={cryptoExtract ?? crypto}
        amount={amount}
        fiat={fiat}
        isSell
      />
    );
  }

  if (isProviderPage) return null;
};

export default WidgetV2;
